// src/hooks/usePreferenceLocale.ts — SCE Issues
// Un réglage de confort retenu dans ce navigateur (bascule « Par machine » de
// l'accueil, périmètre de l'activité…). Ni partagé ni synchronisé : si le
// stockage est bloqué, le réglage vaut la valeur par défaut, rien ne casse.

import { useCallback, useState } from 'react'

export function usePreferenceLocale(cle: string, defaut: boolean): [boolean, (valeur: boolean) => void] {
  const [valeur, setValeur] = useState<boolean>(() => {
    try {
      const lue = localStorage.getItem(cle)
      return lue === null ? defaut : lue === '1'
    } catch {
      return defaut
    }
  })
  const changer = useCallback(
    (v: boolean) => {
      setValeur(v)
      try {
        localStorage.setItem(cle, v ? '1' : '0')
      } catch {
        // préférence de confort : tant pis
      }
    },
    [cle],
  )
  return [valeur, changer]
}
